module.exports = __webpack_public_path__ + "img/banner6.7057cf19.png";